import { returnUniqueChargers } from "../utility/helpers"

// auth state
export const UPDATE_AUTHENTICATING = 'UPDATE_AUTHENTICATING'
export const SHOULD_AUTHENTICATE = 'SHOULD_AUTHENTICATE'

export const initialAuthState = {
    shouldAuthenticate: true,
    isAuthenticating: false
}

export const authReducer = (state, { type, payload }) => {
    switch(type) {
        case UPDATE_AUTHENTICATING:
            return { ...state, isAuthenticating: payload }
        case SHOULD_AUTHENTICATE:
            return { ...state, shouldAuthenticate: payload }
        default:
            return state
    }
}

// map state
export const UPDATE_VIEW_STATE = 'UPDATE_VIEW_STATE'
export const RECEIVE_PINS = 'RECEIVE_PINS'
export const RECEIVE_CHARGERS_IN_VIEWPORT = 'RECEIVE_CHARGERS_IN_VIEWPORT'
export const FETCHING_PINS = 'FETCHING_PINS'
export const SET_SELECTED_PIN = 'SET_SELECTED_PIN'
export const SET_ACTIVE_PIN = 'SET_ACTIVE_PIN'
export const UPDATE_PINS_GEOJSON = 'UPDATE_PINS_GEOJSON'
export const RECEIVE_PINS_FETCH_ERROR = 'RECEIVE_PINS_FETCH_ERROR'
export const CHECKING_LOCATION = 'CHECKING_LOCATION'
export const RECEIVE_SAVED_VIEW = 'RECEIVE_SAVED_VIEW'
export const UPDATE_LOAD_MAP = 'UPDATE_LOAD_MAP'
export const UPDATE_RUNNING_INITIAL_FETCH = 'UPDATE_RUNNING_INITIAL_FETCH'
export const TOGGLE_EXPANDED_FILTER_BUTTON = 'TOGGLE_EXPANDED_FILTER_BUTTON'
export const UPDATE_NON_TESLA_ONLY = 'UPDATE_NON_TESLA_ONLY'

export const NEW_YORK = {
    center: [-74.0060, 40.7128],
    zoom: 8
}

export const US = {
    center: [-98.5795, 38.8238],
    zoom: 4
}

export const initialMapState = {
    viewState: {
        longitude: 0,
        latitude: 0,
        zoom: 1
    },
    savedView: null, // null|{center:[lng:number,lat:number], zoom:number}
    pins: [],
    chargersInViewport: [],
    selectedPin: '',
    activePin: '',
    fetchingPins: false,
    pinsGeoJSON: null,
    pinsFetchError: '',
    checkingLocation: false,
    loadMap: false,
    runningInitialFetch: true, // running the location fetch
    filterExpanded: true,
    showNonTeslaOnly: false
}

export const mapReducer = (state, { type, payload }) => {
    switch(type) {
        case UPDATE_VIEW_STATE:
            return { ...state, viewState: payload }
        case RECEIVE_PINS:
            const oldPins = state.pins
            const updatedPins = returnUniqueChargers(oldPins, payload)
            return { ...state, pins: updatedPins }
        case RECEIVE_CHARGERS_IN_VIEWPORT:
            return { ...state, chargersInViewport: payload }
        case FETCHING_PINS:
            return { ...state, fetchingPins: payload }
        case SET_SELECTED_PIN:
            return { ...state, selectedPin: payload }
        case SET_ACTIVE_PIN:
            return { ...state, activePin: payload }
        case UPDATE_PINS_GEOJSON:
            return { ...state, pinsGeoJSON: payload }
        case RECEIVE_PINS_FETCH_ERROR:
            return { ...state, pinsFetchError: payload }
        case CHECKING_LOCATION:
            return { ...state, checkingLocation: payload }
        case RECEIVE_SAVED_VIEW:
            return { ...state, savedView: payload }
        case UPDATE_LOAD_MAP:
            return { ...state, loadMap: payload }
        case UPDATE_RUNNING_INITIAL_FETCH:
            return { ...state, runningInitialFetch: payload }
        case TOGGLE_EXPANDED_FILTER_BUTTON:
            return { ...state, filterExpanded: payload }
        case UPDATE_NON_TESLA_ONLY:
            return { ...state, showNonTeslaOnly: payload }
        default:
            return state
    }    
}

// charger state

export const RECEIVE_DATA = 'RECEIVE_DATA'
export const FETCHING_DATA = 'FETCHING_DATA'
export const RECEIVE_DATA_ERROR = 'RECEIVE_DATA_ERROR'
export const RECEIVE_POPULAR_TIMES = 'RECEIVE_POPULAR_TIMES'
export const RECEIVE_AWARDS = 'RECEIVE_AWARDS'
export const RECEIVE_POSTS = 'RECEIVE_POSTS'
export const FETCHING_POSTS = 'FETCHING_POSTS'
export const RECEIVE_POSTS_ERROR = 'RECEIVE_POSTS_ERROR'
// export const RECEIVE_PROBLEMS = 'RECEIVE_PROBLEMS'
// export const FETCHING_PROBLEMS = 'FETCHING_PROBLEMS'
// export const RECEIVE_PROBLEMS_ERROR = 'RECEIVE_PROBLEMS_ERROR'
export const RECEIVE_ZAPS = 'RECEIVE_ZAPS'
export const FETCHING_ZAPS = 'FETCHING_ZAPS'
export const RECEIVE_ZAPS_ERROR = 'RECEIVE_ZAPS_ERROR'
export const RECEIVE_ACTIVE_ZAP = 'RECEIVE_ACTIVE_ZAP'
export const FETCHING_RECENT_CHARGES = 'FETCHING_RECENT_CHARGES'
export const RECEIVE_RECENT_CHARGES = 'RECEIVE_RECENT_CHARGES'
export const RECEIVE_RECENT_ERROR = 'RECEIVE_RECENT_ERROR'
export const RESET_ACTIVE_CHARGER_STATE = 'RESET_ACTIVE_CHARGER_STATE'

export const initialChargerState = {
    data: null,
    error: '',
    isFetchingData: false,
    popularTimes: [],
    awards: null,
    posts: [],
    postsError: '',
    isFetchingPosts: false,
    problems: [],
    problemsError: '',
    isFetchingProblems: false,
    zaps: [],
    zapsError: '',
    isFetchingZaps: false,
    activeZap: null,
    recentCharges: [],
    isFetchingRecent: false,
    recentChargesError: ''
}

export const chargersReducer = (state, { type, payload }) => {
	switch (type) {
		case RECEIVE_DATA:
			return { ...state, data: payload }
		case FETCHING_DATA:
			return { ...state, isFetchingData: payload }
		case RECEIVE_DATA_ERROR:
			return { ...state, error: payload }
		case RECEIVE_POPULAR_TIMES:
			return { ...state, popularTimes: payload }
		case RECEIVE_AWARDS:
			return { ...state, awards: payload }
		case RECEIVE_POSTS:
			return { ...state, posts: payload }
		case FETCHING_POSTS:
			return { ...state, isFetchingPosts: payload }
		case RECEIVE_POSTS_ERROR:
			return { ...state, postsError: payload }
		// case RECEIVE_PROBLEMS:
			// return { ...state, problems: payload }
		// case FETCHING_PROBLEMS:
		// 	return { ...state, isFetchingProblems: payload }
		// case RECEIVE_PROBLEMS_ERROR:
			// return { ...state, problemsError: payload }
		case RECEIVE_ZAPS:
			return { ...state, zaps: payload }
		case FETCHING_ZAPS:
			return { ...state, isFetchingZaps: payload }
		case RECEIVE_ZAPS_ERROR:
			return { ...state, zapsError: payload }
		case RECEIVE_ACTIVE_ZAP:
			return { ...state, activeZap: payload }
        case FETCHING_RECENT_CHARGES:
            return { ...state, isFetchingRecent: payload }
        case RECEIVE_RECENT_CHARGES:
            return { ...state, recentCharges: payload }
        case RECEIVE_RECENT_ERROR:
            return { ...state, recentChargesError: payload }
        case RESET_ACTIVE_CHARGER_STATE:
            return { ...initialChargerState }
		default:
			return state
	}
}

// localization state

export const RECEIVE_COUNTRY_CODE = 'RECEIVE_COUNTRY_CODE'
export const RECEIVE_CURRENCY_CODE = 'RECEIVE_CURRENCY_CODE'

export const initialLocalizationState = {
    countryCode: '',
    currencyCode: ''
}

export const localizationReducer = (state, { type, payload }) => {
    switch(type) {
        case RECEIVE_COUNTRY_CODE:
            return { ...state, countryCode: payload }
        case RECEIVE_CURRENCY_CODE:
            return { ...state, currencyCode: payload }
        default:
            return state
    }
}